import { Trans } from '@tuic/i18n';

import { urls } from '../urls';

import type { Locale, TFunction } from '@tuic/i18n';
import type { VideoProps } from '@tuic/web-compositions/shared/Video';

export const getI18nForVideo = (
  locale: Locale,
  t: TFunction,
): VideoProps['i18n'] => {
  return {
    consentMessage: (
      <Trans>
        Beim Abspielen des Videos können persönliche Daten an YouTube
        übermittelt werden. Mehr dazu in unseren{' '}
        <a
          href={urls.privacyPolicy({ locale })}
          target="_blank"
          rel="noreferrer"
        >
          Datenschutzbestimmungen
        </a>
        .
      </Trans>
    ),
    consentButtonLabel: t('Video aktivieren'),
  };
};
